export const getGrades = (state) => state.grades;

export const getAllGrades = (state) => {
	const grades = getGrades(state);
	if (!grades && !grades.allGrades) return null;
	return grades;
};
